<template>
    <div v-if="tableShow">
        <h3 class="title-content mb-5">
            {{ $t('ACTIVATION_CODES') }}
        </h3>

        <v-data-table
            :headers="headers"
            :items="ordersOnCurrentPage"
            :hide-actions="true"
            :no-data-text="$t('EMPTY_LIST')"
            class="elevation-1"
        >
            <template slot="items" slot-scope="props">
                <td v-if="props.item.status.active" class=" text-xs-left">
                    {{ dateFormat(props.item.activationDate) }}
                </td>
                <td v-if="!props.item.status.active" class=" text-xs-left"></td>

                <td v-if="props.item.code" class=" text-xs-left">
                    <div class="text-xs-center text-green">
                        {{ props.item.code }}
                    </div>
                </td>

                <td v-if="props.item.size" class=" text-xs-left">
                    <div class="text-xs-center">
                        {{ props.item.size }}
                    </div>
                </td>

                <td v-if="props.item.code && !props.item.status.old" class="text-xs-center">
                    <span v-if="!props.item.status.codeSend && props.item.status.active">
                        {{ $t('PACKAGE_ACTIVE') }}
                    </span>

                    <span v-if="props.item.status.codeSend">
                        {{ $t('CODE_SENT') }}
                    </span>

                    <div v-if="!props.item.status.active && !props.item.status.codeSend" class="text-xs-center">
                        <button class="app-btn app-btn--small app-btn-default" @click="showWindowModal(props.item)">
                            {{ $t('ACTIVATE_PACKAGE') }}
                        </button>
                        <br />
                        <span
                            v-if="!props.item.status.onlyActive"
                            class="link--small"
                            @click="showWindowModalSend(props.item)"
                        >
                            {{ $t('OR_SEND_CODE') }}
                        </span>
                    </div>
                </td>
                <td v-if="props.item.code && props.item.status.old" class="text-xs-center">
                    <span>
                        {{ $t('OVERDUE_PACKAGE') }}
                    </span>
                </td>

                <td class=" text-xs-left">
                    {{ props.item.expireDate }}
                </td>
            </template>
        </v-data-table>
        <div v-if="numberOfPages > 1">
            <v-pagination
                :length="numberOfPages"
                :total-visible="numberOfTotalVisiblePages"
                prev-icon="arrow_back"
                next-icon="arrow_forward"
                v-model="currentlyDisplayedPage"
            ></v-pagination>
        </div>

        <!--MODAL-->
        <modal v-if="showModal" @close="closeModal">
            <activate-another-package
                :activepackage="this.choosemItem"
                @close="closeModal"
                @activate="activatePackage"
                v-if="isPackageActive()"
            >
            </activate-another-package>

            <activate-package
                :activepackage="getChoosenPackage()"
                @close="closeModal"
                @activate="activatePackage"
                v-else
            >
            </activate-package>
        </modal>

        <modal v-if="sendPackageModal" @close="closeModal">
            <send-package :activepackage="this.choosemItem" @close="closeModal" @sendPackage="sendPackage">
            </send-package>
        </modal>

        <div class="rotate-phone mobile">
            <p class="rotate-phone__text">
                {{ $t('ROTATE_PHONE') }}
            </p>
        </div>
    </div>
</template>

<script>
import Modal from '../../modals/_modal.vue';
import ActivatePackage from '../../modals/activate-package.vue';
import ActivateAnotherPackage from '../../modals/activate-another-package.vue';
import SendPackage from '../../modals/send-activating-code.vue';
import moment from 'moment';

export default {
    data() {
        return {
            showModal: false,
            choosemItem: null,
            sendPackageModal: false,
            headers: [
                { text: this.$t('ACTIVATION_DATE'), value: 'date', align: 'left' },
                { text: this.$t('CODE'), value: 'number', align: 'left' },
                { text: this.$t('COUNT'), value: 'number', align: 'left' },
                { text: this.$t('ACTIONS'), value: 'actions', align: 'left' },
                { text: this.$t('EXPIRATION_DATE'), value: 'date', align: 'left' },
            ],
            orders: [],
            codes: [],
            tableShow: false,
            lastStockExpirationDate: null,
            currentlyDisplayedPage: 1,
            numberOfOrdersOnOnePage: 5,
        };
    },
    methods: {
        showWindowModal(item) {
            this.choosemItem = item;
            this.choosemItem.lastStockExpirationDate = this.lastStockExpirationDate;
            this.showModal = true;
        },
        showWindowModalSend(item) {
            this.choosemItem = item;
            this.sendPackageModal = true;
        },
        getChoosenPackage() {
            if (this.choosemItem) {
                this.choosemItem.lastStockExpirationDate = this.lastStockExpirationDate;
            }
            return this.choosemItem;
        },
        closeModal() {
            this.showModal = false;
            this.sendPackageModal = false;
        },
        isPackageActive() {
            return this.$moment(this.lastStockExpirationDate) > this.$moment(Date.now());
        },
        activatePackage() {
            this.closeModal();
            this.orders = [];
            this.tableShow = false;
            this.$http.post('/user/api/profile/activatePackage', { code: this.choosemItem.code }).then(this.getOrders);
        },
        sendPackage() {
            this.tableShow = false;
            const data = {
                name: document.getElementById('nameWoman').value,
                mail: document.getElementById('loginEmail').value,
                code: this.choosemItem.code,
            };
            this.$http.post(`/user/api/profile/sendPackageToFriend`, data).then(this.getOrders);
            this.closeModal();
        },
        getOrders() {
            this.tableShow = true;
            let url = `/user/api/shop/getActivationCodes/`;
            this.$http.get(url, { emulateJSON: true }).then(response => {
                let codes = [];
                response.body.forEach(function(pack) {
                    var codeView = false;
                    var codeActive = false;
                    var codeSend = false;
                    var old = false;
                    var onlyActive = false;
                    var size = pack.packageSizeExamination;
                    // pack.packageStatus

                    if (pack.packageActivation != null) {
                        codeActive = true;
                    }

                    if (pack.codeBeneficent != null) {
                        codeSend = true;
                    }

                    if (pack.onlyActive != null) {
                        onlyActive = pack.onlyActive;
                    }

                    if (moment(pack.packageValid) < moment(Date.now()) && !codeActive) {
                        old = true;
                    }

                    if (pack.code.indexOf('anually') < 0 && pack.code.indexOf('refund') < 0) {
                        codes.push({
                            code: pack.code,
                            activationDate: pack.packageActivation,
                            expireDate: pack.packageExpirationDate,
                            status: {
                                active: codeActive,
                                view: codeView,
                                old: old,
                                codeSend: codeSend,
                                onlyActive: onlyActive,
                            },
                            size: size,
                        });
                    }
                });
                this.codes = codes;
            });
        },
    },
    computed: {
        numberOfPages() {
            return Math.ceil(this.codes.length / this.numberOfOrdersOnOnePage);
        },
        numberOfTotalVisiblePages() {
            return this.numberOfPages < 10 ? this.numberOfPages : 10;
        },
        ordersOnCurrentPage() {
            return this.codes.slice(
                (this.currentlyDisplayedPage - 1) * this.numberOfOrdersOnOnePage,
                this.currentlyDisplayedPage * this.numberOfOrdersOnOnePage,
            );
        },
    },
    components: {
        Modal,
        ActivatePackage,
        ActivateAnotherPackage,
        SendPackage,
    },
    created() {
        this.$http.get('/user/api/profile/lastTokenExpirationDate/').then(response => {
            this.lastStockExpirationDate = this.$moment(response.bodyText).format('YYYY-MM-DD');
            this.getOrders();
        });
    },
};
</script>

<style scoped>
.text-green {
    color: #0e9604;
}

.link--small {
    color: #cf004a;
    cursor: pointer;
    font-size: 12px;
    font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// activation-codes.vue?598b3662